import { render, staticRenderFns } from "./CharacterForm.vue?vue&type=template&id=346c65ae&scoped=true&"
import script from "./CharacterForm.vue?vue&type=script&lang=ts&"
export * from "./CharacterForm.vue?vue&type=script&lang=ts&"
import style0 from "./CharacterForm.vue?vue&type=style&index=0&id=346c65ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346c65ae",
  null
  
)

export default component.exports